import { Typography, Stack, useTheme } from "@mui/material";
import { IngredientFormCompany } from "../../../IngredientForm.types";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

type OwnedByFieldProps = {
    value: IngredientFormCompany | null;
    onChange: (v: IngredientFormCompany) => void;
};

export const OwnedByField = ({ value, onChange }: OwnedByFieldProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    // Someone implemented a second form under the original one, therefore, since this is read-only
    // It needs synchronization
    useEffect(() => {
        if (value !== null) {
            // Immediate synchronization on mount
            onChange(value);
        }
    }, []);

    return (
        <Stack flexDirection="column" gap={1} maxWidth="70%">
            <Typography variant="body-semibold">
                {t("entity.organization.owning_entity.label", `Owning entity (non-editable):`)}
            </Typography>
            <Typography
                variant={"small-bold"}
                sx={{
                    width: "fit-content",
                    padding: theme.spacing(0.5, 2),
                    // border: `1px solid red`,
                    backgroundColor: theme.palette.primary[50],
                    color: theme.palette.primary[500],
                    borderRadius: "25px",
                }}
            >
                {value?.name}
            </Typography>
        </Stack>
    );
};
